"use client";

import { FC } from "react";
import { SwiperSlide } from "swiper/react";
import Carousel from "apps/website/components/feature/Carousel/Carousel";

import SurveyCard, { ISurveyCardProps } from "../../Card/SurveyCard/SurveyCard";

export interface ISurveyCardCarouselProps {
  items: ISurveyCardProps[]
}

const SurveyCardCarousel: FC<ISurveyCardCarouselProps> = ({ items }) => (
  <Carousel component="SurveyCardCarousel" breakpoints={{ default: 1, md: 2, lg: 3 }}>
    { items.map((survey, index) => (
      <SwiperSlide key={ survey.link} style={{ height: "auto" }}>
        <SurveyCard { ...survey } title={ `${index + 1}. ${survey.title}`}/>
      </SwiperSlide>
    )) }
  </Carousel>
);
export default SurveyCardCarousel;
